



// ***************** les cours payer par l'utilisateur connecté **********
import React, { useState, useEffect } from "react";
import { Card, Button, Spin, Alert, message, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import { ShoppingCartOutlined, EyeOutlined, CalendarOutlined, DollarCircleOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";
import API_BASE from "../../config/apiConfig";

const API_BASE_URL = `${API_BASE}/images/proxy`;

const MyPurchases = () => {
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 📋 Récupération de l'userId depuis localStorage
  const getUserId = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.id || null;
  };

  const getUserInfo = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return {
      id: user.id,
      email: user.email || '',
      username: user.username || '',
      name: user.name || user.username || 'Utilisateur'
    };
  };

  /**
   * ✅ CORRIGÉ : Génère l'URL du proxy directement (comme la page d'accueil)
   * Le proxy est en permitAll, pas besoin d'authentification
   */
  const getProxyImageUrl = (imageUrl) => {
    if (!imageUrl) return "/default-image.png";
    return `${API_BASE_URL}?url=${encodeURIComponent(imageUrl)}`;
  };

  // 🎨 Fonction pour formater la date
  const formatDate = (dateString) => {
    if (!dateString) return "Date inconnue";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  useEffect(() => {
    const fetchMyPurchases = async () => {
      try {
        const userId = getUserId();
        if (!userId) {
          setError("Vous devez être connecté pour voir vos achats.");
          setLoading(false);
          return;
        }

        console.log("🔍 Récupération des achats pour l'utilisateur:", userId);

        // ✅ Utilise la bonne méthode pour récupérer les achats de l'utilisateur
        const purchasesResponse = await courseService.getMyPurchases2(userId);
        
        console.log("📦 Achats reçus:", purchasesResponse);

        if (!purchasesResponse || purchasesResponse.length === 0) {
          console.log("ℹ️ Aucun achat trouvé pour cet utilisateur");
          setPurchases([]);
          setLoading(false);
          return;
        }

        // ✅ CORRIGÉ : Utiliser l'URL du proxy directement (sans fetch)
        const updatedPurchases = purchasesResponse.map((purchase) => {
          // Construire l'URL du proxy directement
          const imageUrl = purchase.course?.image 
            ? getProxyImageUrl(purchase.course.image)
            : "/default-image.png";

          return {
            ...purchase,
            imageUrl: imageUrl,
            id: purchase.course?.id || purchase.courseId,
            title: purchase.course?.title || `Cours ${purchase.courseId}`,
            latest_price: purchase.amount ? (purchase.amount / 100).toFixed(2) : purchase.course?.latest_price,
            lessons: purchase.course?.lessons || "Non spécifié",
            currency: purchase.currency || "USD"
          };
        });

        setPurchases(updatedPurchases);
        console.log("✅ Achats traités avec succès:", updatedPurchases);

      } catch (err) {
        console.error("❌ Erreur lors de la récupération des achats:", err);
        setError("Impossible de récupérer vos achats. Veuillez réessayer.");
      } finally {
        setLoading(false);
      }
    };

    fetchMyPurchases();
  }, []);

  if (loading) {
    return (
        <div style={{
            minHeight: "100vh",
            background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px"
        }}>
            <div style={{
                background: "rgba(255, 255, 255, 0.95)",
                borderRadius: "24px",
                padding: "60px 40px",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
                maxWidth: "500px",
                width: "100%",
                backdropFilter: "blur(10px)"
            }}>
                <div style={{
                    position: "relative",
                    display: "inline-block",
                    marginBottom: "30px"
                }}>
                    <Spin 
                        size="large" 
                        style={{
                            fontSize: "48px"
                        }}
                    />
                    <div style={{
                        position: "absolute",
                        top: "-10px",
                        left: "-10px",
                        width: "80px",
                        height: "80px",
                        border: "3px solid rgba(82, 196, 26, 0.2)",
                        borderRadius: "50%",
                        animation: "pulse 2s infinite"
                    }}></div>
                </div>

                <h2 style={{
                    color: "#2c3e50",
                    fontSize: "28px",
                    fontWeight: "700",
                    marginBottom: "12px",
                    background: "linear-gradient(45deg, #52c41a, #389e0d)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent"
                }}>
                    Chargement de vos achats
                </h2>

                <p style={{
                    color: "#7f8c8d",
                    fontSize: "16px",
                    marginBottom: "30px",
                    lineHeight: "1.5"
                }}>
                    Récupération de vos cours achetés en cours...
                </p>

                <div style={{
                    width: "100%",
                    height: "6px",
                    backgroundColor: "#ecf0f1",
                    borderRadius: "3px",
                    overflow: "hidden",
                    marginBottom: "20px"
                }}>
                    <div style={{
                        height: "100%",
                        background: "linear-gradient(90deg, #52c41a, #389e0d, #52c41a)",
                        backgroundSize: "200% 100%",
                        animation: "loading 2s linear infinite",
                        borderRadius: "3px"
                    }}></div>
                </div>

                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px"
                }}>
                    {[0, 1, 2].map((i) => (
                        <div
                            key={i}
                            style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: "#52c41a",
                                borderRadius: "50%",
                                animation: `bounce 1.4s infinite ease-in-out ${i * 0.16}s`
                            }}
                        />
                    ))}
                </div>

                <div style={{
                    marginTop: "20px",
                    fontSize: "24px",
                    opacity: "0.7"
                }}>
                    🛒
                </div>
            </div>

            <style>
                {`
                    @keyframes loading {
                        0% { background-position: 200% 0; }
                        100% { background-position: -200% 0; }
                    }
                    
                    @keyframes pulse {
                        0% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.1); opacity: 0.7; }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    
                    @keyframes bounce {
                        0%, 80%, 100% { 
                            transform: scale(0);
                            opacity: 0.5;
                        }
                        40% { 
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                `}
            </style>
        </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px" }}>
        <Alert message="Erreur" description={error} type="error" showIcon />
      </div>
    );
  }

  const userInfo = getUserInfo();

  return (
    <div className="my-purchases-container" style={{ padding: "20px" }}>
      {/* En-tête personnalisé */}
      <div style={{ 
        textAlign: "center", 
        marginBottom: "30px",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        border: "1px solid #e0e0e0"
      }}>
        <h1 style={{ 
          color: "#004b8d", 
          margin: "0 0 8px 0",
          fontSize: "28px",
          fontWeight: "bold"
        }}>
          🛒 Mes Achats
        </h1>
        <p style={{ 
          color: "#666", 
          margin: "0",
          fontSize: "16px"
        }}>
          Bienvenue <strong>{userInfo.name}</strong> ! Voici vos cours achetés.
        </p>
        {purchases.length > 0 && (
          <p style={{ 
            color: "#004b8d", 
            margin: "8px 0 0 0",
            fontSize: "14px",
            fontWeight: "600"
          }}>
            📚 {purchases.length} cours acheté{purchases.length > 1 ? 's' : ''}
          </p>
        )}
      </div>

      {/* Liste des achats */}
      {purchases.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <div>
                <h3 style={{ color: "#666" }}>Aucun cours acheté</h3>
                <p style={{ color: "#999" }}>
                  Vous n'avez encore acheté aucun cours. 
                  <br />
                  Explorez notre catalogue pour commencer votre apprentissage !
                </p>
              </div>
            }
          >
            <Button 
              type="primary" 
              style={{ backgroundColor: "#004b8d", borderColor: "#004b8d" }}
              onClick={() => navigate('/courses')}
            >
              Découvrir les cours
            </Button>
          </Empty>
        </div>
      ) : (
        <div
          className="purchases-list"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            justifyContent: purchases.length === 1 ? "center" : "flex-start",
          }}
        >
          {purchases.map((purchase) => (
            <Card
              key={`${purchase.id}-${purchase.paymentIntentId || purchase.purchasedAt}`}
              hoverable
              style={{
                width: "300px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                border: "1px solid #e0e0e0",
                transition: "all 0.3s ease"
              }}
              cover={
                <div style={{ 
                  height: "180px", 
                  overflow: "hidden", 
                  borderBottom: "1px solid #e0e0e0",
                  position: "relative"
                }}>
                  <img
                    alt={purchase.title}
                    src={purchase.imageUrl || "/default-image.png"}
                    style={{ 
                      width: "100%", 
                      height: "100%", 
                      objectFit: "cover", 
                      transition: "transform 0.3s" 
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/default-image.png";
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                    }}
                  />
                  {/* Badge "Acheté" */}
                  <div style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: "#52c41a",
                    color: "white",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: "bold"
                  }}>
                    ✅ Acheté
                  </div>
                </div>
              }
            >
              <Card.Meta
                title={
                  <span style={{ 
                    fontWeight: "bold", 
                    color: "#004b8d",
                    fontSize: "16px"
                  }}>
                    {purchase.title}
                  </span>
                }
                description={
                  <div style={{ marginTop: "12px" }}>
                    {/* Prix payé */}
                    <div style={{ 
                      display: "flex", 
                      alignItems: "center", 
                      marginBottom: "8px",
                      padding: "8px",
                      backgroundColor: "#f6f8fa",
                      borderRadius: "6px"
                    }}>
                      <DollarCircleOutlined style={{ color: "#52c41a", marginRight: "6px" }} />
                      <span style={{ fontWeight: "600", color: "#52c41a" }}>
                        Payé : {purchase.latest_price} {purchase.currency?.toUpperCase()}
                      </span>
                    </div>

                    {/* Informations du cours */}
                    <div style={{ marginBottom: "8px" }}>
                      <span style={{ color: "#666", fontSize: "14px" }}>
                        📚 <strong>Leçons :</strong> {purchase.lessons}
                      </span>
                    </div>

                    {/* Date d'achat */}
                    {purchase.purchasedAt && (
                      <div style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        color: "#888", 
                        fontSize: "13px",
                        marginTop: "8px"
                      }}>
                        <CalendarOutlined style={{ marginRight: "6px" }} />
                        <span>Acheté le {formatDate(purchase.purchasedAt)}</span>
                      </div>
                    )}

                    {/* ID de transaction */}
                    {purchase.paymentIntentId && (
                      <div style={{ 
                        fontSize: "11px", 
                        color: "#999",
                        marginTop: "4px",
                        fontFamily: "monospace"
                      }}>
                        Transaction : {purchase.paymentIntentId}
                      </div>
                    )}
                  </div>
                }
              />

              {/* Boutons d'action */}
              <div style={{ 
                display: "flex", 
                gap: "8px", 
                marginTop: "16px",
                padding: "0 8px 8px 8px"
              }}>
                <Button
                  type="default"
                  style={{ 
                    flex: 1,
                    borderColor: "#004b8d",
                    color: "#004b8d"
                  }}
                  icon={<EyeOutlined />}
                  onClick={() => navigate(`/learning/course/${purchase.id}`)}
                >
                  Voir détails
                </Button>

                <Button
                  type="primary"
                  style={{ 
                    flex: 2, 
                    backgroundColor: "#004b8d", 
                    borderColor: "#004b8d",
                    fontWeight: "600"
                  }}
                  icon={<ShoppingCartOutlined />}
                  onClick={() => navigate(`/learning/course/${purchase.id}`)}
                >
                  Commencer
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyPurchases;